export default '–';
